import SessionEventProto from "../session-event-proto";
import ChatsCollection from "../../model2/chat/chat/collection";


export default class SessionEvent_ChatRoomsReset extends SessionEventProto {

    // private header  : Header

    constructor(sessionEvent:any) {
        super(sessionEvent)

        // this.header     = {
        //     expense     : sessionEvent.expense,
        //     isBulkUpdate: sessionEvent.isBulkUpdate,
        // }
    }

    process() {
        if (this.isDifferentCompany()) return false;

        // Now we always have it... so always reset
        gd.session.chats.reset(ChatsCollection.initFromJson(this.data).models)

        // if (!gd.session.chats) {
        //     gd.session.chats = ChatsCollection.initFromJson(this.data)
        // } else {
        //     gd.session.chats.reset(ChatsCollection.initFromJson(this.data).models)
        // }

    }
};